import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';

const navLink = (active) => ({
    padding: '8px 16px',
    borderRadius: '100px',
    color: active ? '#fff' : 'rgba(255,255,255,0.85)',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    background: active ? 'rgba(255,255,255,0.2)' : 'transparent'
});

const drawerLinkClass = (active) => `nav-touch${active ? ' landing-drawer-active' : ''}`;

export default function LandingHeader() {
    const { pathname } = useLocation();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { t } = useTranslation('landing');

    const links = [
        { to: '/', label: t('header.home'), key: 'home' },
        { to: '/pricing', label: t('header.pricing'), key: 'pricing' },
        { to: '/login', label: t('header.login'), key: 'login' },
        { to: '/register', label: t('header.register'), key: 'register' },
    ];

    return (
        <>
            <header className="sp-header landing-header">
                <Link to="/" className="sp-header__brand">
                    <Logo variant="dark" height={38} />
                </Link>

                <nav className="landing-nav-desktop" style={{ alignItems: 'center', gap: 8 }}>
                    <Link to="/" className="nav-touch sp-header__nav-link" style={navLink(pathname === '/')}>
                        {t('header.home')}
                    </Link>
                    <Link to="/pricing" className="nav-touch sp-header__nav-link" style={navLink(pathname === '/pricing')}>
                        {t('header.pricing')}
                    </Link>
                    <Link to="/login" className="nav-touch sp-header__btn-outline" style={{ marginLeft: '8px', textDecoration: 'none' }}>
                        {t('header.login')} →
                    </Link>
                    <Link
                        to="/register"
                        className="nav-touch"
                        style={{
                            padding: '8px 20px',
                            borderRadius: '100px',
                            background: 'white',
                            color: '#EB3333',
                            fontSize: '14px',
                            textDecoration: 'none',
                            fontWeight: 700,
                            marginLeft: '8px',
                            textTransform: 'uppercase',
                        }}
                    >
                        {t('header.register')}
                    </Link>
                    <LanguageSwitcher className="sp-header__locale" variant="compact" menuAlign="end" />
                </nav>

                <button
                    type="button"
                    className="sp-header__burger landing-burger-btn"
                    aria-label={t('header.openMenu')}
                    onClick={() => setDrawerOpen(true)}
                >
                    ☰
                </button>
            </header>

            {drawerOpen && (
                <div className="landing-drawer-overlay" onClick={() => setDrawerOpen(false)} role="presentation" />
            )}
            {drawerOpen && (
                <div className="landing-drawer">
                    <div style={{ marginBottom: 16 }}>
                        <LanguageSwitcher variant="select" />
                    </div>
                    <button type="button" className="landing-drawer-close" onClick={() => setDrawerOpen(false)} aria-label={t('header.closeMenu')}>
                        ×
                    </button>
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            className={drawerLinkClass(pathname === l.to)}
                            onClick={() => setDrawerOpen(false)}
                        >
                            {l.label}
                        </Link>
                    ))}
                </div>
            )}
        </>
    );
}
